// src/services/noteService.js
import api from "./api";

export function fetchNotes() {
  return api.get("/notes");
}

export function getNoteById(id) {
  return api.get(`/notes/${id}`);
}

// >>> NOVO: grupos disponíveis para o filtro "Por grupo" de uma atividade
// (grupos criados pelo usuário logado com algum membro autor de nota na atividade).
export function getFilterableGroupsForActivity(activityId) {
  return api.get(`/notes/activity/${activityId}/filterable-groups`);
}

// NOVO: Método para buscar notas criadas por um usuário específico em uma atividade.
// 🆕 ADICIONADO: Função que mapeia para o endpoint /by-creator-and-activity/{targetUserId}/{activityId}
export function getNotesByCreatorAndActivity(
  targetUserId, // 🚨 CORRIGIDO: Renomeado para targetUserId (ou mantido createdByUserId)
  activityId,
  includeOnlyOthers = false, // 🚨 ADICIONADO: Define um valor padrão
) {
  // 🚨 CORREÇÃO: Usar targetUserId na rota e enviar includeOnlyOthers como parâmetro de consulta (params)
  return api.get(
    `/notes/by-creator-and-activity/${targetUserId}/${activityId}`,
    {
      params: {
        includeOnlyOthers, // Axios enviará ?includeOnlyOthers=true/false
      },
    },
  );
}

export function createNote(data, useElastic = false) {
  return api.post("/notes", data, {
    params: { useElastic },
  });
}

// src/services/noteService.js

export function createNotesBatch(data, useElastic = false) {
  // data esperado: array de objetos NoteCreateDto
  // Exemplo: [ { title, body, activityId, textRangeStart, textRangeEnd, ... }, ... ]
  return api.post("/notes/bulk-add", data, {
    params: { useElastic },
  });
}

export function updateNote(data, useElastic = false) {
  console.log("dentro do noteService");
  return api.put(`/notes/${data.noteId}`, data, {
    params: { useElastic },
  });
}

// 🆕 NOVO: atualizar notas em lote
// data esperado: objeto com { noteIds, updateTag, updateTitle, ... } (payload do BulkEditNoteForm)
export function updateNotesBatch(data, useElastic = false) {
  return api.put("/notes/bulk-update", data, {
    params: { useElastic },
  });
}

export function deleteNote(id, useElastic = false) {
  return api.delete(`/notes/${id}`, {
    params: { useElastic },
  });
}

export function deleteNotesBatch(ids, useElastic = false) {
  return api.delete("/notes", {
    params: { useElastic },
    data: ids,
  });
}

export async function fetchNotesPaged(pageNumber, pageSize, search = "") {
  return api.get("/notes/paged", {
    params: {
      pageNumber,
      pageSize,
      search,
    },
  });
}

// NOVO: Método para buscar todas as notas associadas a uma atividade
export function getNotesByActivityId(
  activityId,
  includeOwn,
  includeComments,
  sortBy,
  // 🆕 ADICIONADO: Novo parâmetro para IDs de usuário
  selectedUserIds = [],
) {
  return api.get(`/notes/by-activity/${activityId}`, {
    params: {
      includeOwn,
      includeComments,
      sortBy,
      // 🆕 INCLUÍDO: Permite que o axios serialize a lista
      selectedUserIds,
    },
  });
}

// NOVO: Método para buscar notas paginadas por activityId
// MÉTODO PRINCIPAL: Lida com todos os cenários de busca
// MÉTODO PRINCIPAL: Lida com todos os cenários de busca
export function fetchNotesByActivityIdPaged(
  activityId,
  pageNumber,
  pageSize,
  search = "",
  includeOwn = true,
  includeComments = true,
  // Ausente = "newest", espelhando o padrão do endpoint. O padrão de PRODUTO
  // (ordem do texto) mora na store, não aqui: este é só o valor de transporte.
  sortBy = "newest",
  selectedUserIds = [],
  selectedGroupIds = [],
  // >>> NOVO: tipos de observação selecionados (substitui withObservation).
  // Ex.: ["Observation", "Correct"]. Vazio = backend não aplica filtro por tipo.
  observationTypes = [],
  // >>> NOVOS: filtros de campo e período
  filterByTitle = "",
  filterByBody = "",
  filterByTag = "",
  filterBySource = "",
  periodField = "",
  periodDateFrom = "",
  periodDateTo = "",
  // >>> NOVO: filtro "Notas avulsas" (textRangeStart == 0 && textRangeEnd == 0)
  onlyStandalone = false,
  // >>> NOVO: busca textual local no campo observação (independente de search global)
  observationSearch = "",
  // >>> NOVO: estado de leitura da observação — "read" | "unread" ("" = sem filtro)
  observationReadState = "",
) {
  const params = {
    pageNumber,
    pageSize,
    search,
    includeOwn,
    includeComments,
    sortBy,
    selectedUserIds,
    selectedGroupIds,
    observationTypes,
    filterByTitle,
    filterByBody,
    filterByTag,
    filterBySource,
    onlyStandalone, // >>> NOVO
  };

  // Busca na observação: só inclui quando há termo (evita param vazio)
  if (observationSearch && observationSearch.trim() !== "")
    params.observationSearch = observationSearch.trim();

  // Estado de leitura: só inclui quando definido (evita param vazio)
  if (observationReadState) params.observationReadState = observationReadState;

  // Período: só inclui se não for vazio — evita binding incorreto no backend
  if (periodField) params.periodField = periodField;
  if (periodDateFrom && periodDateFrom.trim() !== "")
    params.periodDateFrom = periodDateFrom;
  if (periodDateTo && periodDateTo.trim() !== "")
    params.periodDateTo = periodDateTo;

  return api.get(`/notes/by-activity-paged/${activityId}`, {
    params: params,
  });
}

export function updateNoteObservation(noteId, observationData) {
  // Chama o novo endpoint específico
  return api.put(`/notes/${noteId}/observation`, observationData);
}

export function updateNoteObservationRead(noteId, data) {
  // data esperado: { isObservationRead: true/false, noteId?: number }
  return api.put(`/notes/${noteId}/observation-read`, data);
}

// --- NOVOS MÉTODOS PARA PERMISSÕES ---

/**
 * Adiciona uma permissão a uma nota para um usuário específico.
 * @param {number} noteId O ID da nota.
 * @param {object} permissionData Dados da permissão (userId, permissionId).
 */
export function addNotePermission(noteId, permissionData) {
  return api.post(`/notes/${noteId}/permissions`, {
    ...permissionData,
    noteId,
  });
}

/**
 * Remove uma permissão específica de uma nota para um usuário.
 * @param {number} noteId O ID da nota.
 * @param {number} userId O ID do usuário.
 * @param {number} permissionId O ID da permissão.
 */
export function removeNotePermission(noteId, userId, permissionId) {
  return api.delete(`/notes/${noteId}/permissions`, {
    params: { userId, permissionId },
  });
}

/**
 * Obtém todas as permissões associadas a uma nota.
 * @param {number} noteId O ID da nota.
 */
export function fetchNotePermissions(noteId) {
  return api.get(`/notes/${noteId}/permissions`);
}

// FUNÇÃO ATUALIZADA
// NOVO: Método para exportar notas para PDF
// Mapeia para o endpoint POST /api/Texts/{textId}/export-notes-pdf
export function exportNotesPdf(textId, data) {
  // 'data' deve conter { noteIds, includeGlobalNotes, exportMode }
  return api.post(`/Texts/${textId}/export-notes-pdf`, data, {
    // 💡 MUDANÇA ESSENCIAL: Diz ao Axios para tratar a resposta como dados binários de arquivo (BLOB)
    responseType: "blob",
  });
}

// ============================================================
// PATCH CIRÚRGICO — noteService.js
// Adicionar as três funções abaixo no final do arquivo,
// antes do último fechamento de módulo (se houver).
// Nenhuma função existente é alterada.
// ============================================================

/**
 * Gera (ou recupera) o link de compartilhamento público de uma nota.
 * Apenas o dono da nota ou SysAdmin pode chamar.
 * @param {number} noteId
 * @returns {Promise<{ shareToken: string, shareUrl: string }>}
 */
export function generateShareToken(noteId) {
  return api.post(`/notes/${noteId}/share`);
}

/**
 * Revoga o link de compartilhamento de uma nota.
 * Após a revogação o link anterior retorna 404.
 * @param {number} noteId
 */
export function revokeShareToken(noteId) {
  return api.delete(`/notes/${noteId}/share`);
}

/**
 * Endpoint público — não requer autenticação.
 * Busca os dados públicos de uma nota pelo share token.
 * @param {string} shareToken
 * @returns {Promise<SharedNotePublicDto>}
 */
export function getPublicNoteByToken(shareToken) {
  return api.get(`/notes/public/${shareToken}`);
}

/**
 * Retorna o conteúdo completo do arquivo de texto pelo textId.
 * Endpoint público — não requer autenticação.
 * Usado por NotePublicView.vue para extrair o trecho selecionado.
 * @param {number} textId
 * @returns {Promise<string>} conteúdo bruto do arquivo
 */
export function getPublicTextContent(textId) {
  return api.get(`/Texts/${textId}/public-content`);
}

/**
 * Gera notas automaticamente com IA para uma atividade.
 * @param {{ activityId: number, tagIds: number[], count: number, permissions?: object[] }} payload
 * @returns {Promise<{ createdNotes: NoteReadDto[], createdCount: number, warnings: string[] }>}
 */
export function generateNotesWithAi(payload) {
  return api.post("/notes/generate-with-ai", payload);
}

/**
 * Gera e persiste UMA nota assistida por IA a partir de um trecho selecionado.
 * @param {{ activityId, textRangeStart, textRangeEnd, tagIds, title, prompt, contextWindowSize, permissions }} payload
 * @returns {Promise<NoteReadDto>}
 */
export function createNoteWithAi(payload) {
  return api.post("/notes/create-with-ai", payload);
}
